import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight, FaTrophy, FaUsers, FaMedal, FaHeart } from 'react-icons/fa';
import './About.css';

const FitnessConditioningProgram = () => {

    return (
        <div className="about-page">
            {/* Main About Section */}
            <section className="about-main section">
                <div className="container">
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Fitness & Conditioning Program</h2>
                            <p>
                                The Fitness & Conditioning Program at Net Nest Badminton Sports Club is designed to build strong, agile, and injury-resistant players. This program focuses on improving overall physical performance, endurance, and athletic ability, which are essential for consistent performance in badminton at all levels.
                            </p>
                            <h2>Program Overview</h2>
                            <p>
                                Badminton is a fast-paced sport that demands speed, strength, agility, and stamina. Our fitness and conditioning program is structured to meet these demands by combining scientific training methods with sport-specific exercises, helping players perform at their best on the court.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <img src="img/Fitness & Conditioning Training.jpg" alt="Badminton Court" className="main-image" />
                        </div>
                    </div>
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Strength Development</h2>
                            <p>
                                Build core stability and balance
                                <br></br>
                                Improve lower-body strength for powerful movement
                                <br></br>
                                Enhance upper-body strength for better shot control
                                <br></br>
                                Support injury prevention and joint stability
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Speed, Agility & Quickness Training</h2>
                            <p>
                                Reaction time and explosive movement
                                <br></br>
                                Multi-directional footwork
                                <br></br>
                                Court coverage and recovery speed
                                <br></br>
                                Coordination and balance under pressure
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Endurance & Stamina Building</h2>
                            <p>
                                Cardiovascular endurance training
                                <br></br>
                                High-intensity interval exercises
                                <br></br>
                                Match-specific stamina drills
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Flexibility & Mobility Training</h2>
                            <p>
                                Dynamic and static stretching routines
                                <br></br>
                                Mobility exercises for joints and muscles
                                <br></br>
                                Post-training recovery sessions
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Injury Prevention & Recovery</h2>
                            <p>
                                Proper warm-up and cool-down routines
                                <br></br>
                                Muscle strengthening to protect joints
                                <br></br>
                                Recovery techniques and rest management
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Mental & Physical Discipline</h2>
                            <p>
                                Mental toughness and focus
                                <br></br>
                                Training discipline and consistency
                                <br></br>
                                Confidence in physical ability
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Suitable for All Player Levels</h2>
                            <p>
                                Beginner and intermediate players
                                <br></br>
                                Advanced and competitive athletes
                                <br></br>
                                Players preparing for tournaments
                                <br></br>
                                Individuals aiming to improve overall fitness
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default FitnessConditioningProgram;